<template>
	<div class="sub-values">
		<InfoItem v-if="job.careerLevel">
			<template #label>Berufsebene</template>
			<template #content>
				<Label
					:characteristic="job.careerLevel"
					:label-type="labelTypeApplication"
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="job.functions && job.functions.length > 0">
			<template #label>Tätigkeiten</template>
			<template #content>
				<LabelList
					:characteristics="extractCharacteristic(job.functions)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="job.industrialSectors && job.industrialSectors.length > 0">
			<template #label>Branchen</template>
			<template #content>
				<LabelList
					:characteristics="extractCharacteristic(job.industrialSectors)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="job.organisationalArea && job.organisationalArea.length > 0">
			<template #label>Organisationsbereiche</template>
			<template #content>
				<LabelList
					:characteristics="extractCharacteristic(job.organisationalArea)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="job.companyWebsite">
			<template #label>Website</template>
			<template #content>{{job.companyWebsite}}</template>
		</InfoItem>
		<div v-if="job.description" v-html="job.description" class="mt-2"/>
	</div>
</template>

<script>
import InfoItem from "@/vue/application/profile/skills/InfoItem.vue";
import Label from "@/vue/characteristic/Label.vue";
import LabelList from "@/vue/characteristic/LabelList.vue";
import {APPLICATION} from "@/helper/characteristic/Label";

export default {

	components: {
		InfoItem,
		Label,
		LabelList,
	},

	props: {
		job: {
			type: Object,
			required: true,
		}
	},

	computed: {
		labelTypeApplication ()
		{
			return APPLICATION;
		},
	},

	methods: {
		extractCharacteristic (items)
		{
			return items.map(item => item.item);
		}
	}
}
</script>
